import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { IFixedFilter } from "@/shared/models/view/fixed-filter-model";
import { PureAzureSearchService, Query } from "@/shared/services/azure-search-service";
import { PureResultsMapper } from "../../mappings/pure-search-response-mapper";
import { IFilterItem } from "../../models/filter-item-model";
import { IPureSearchIndex, Locale } from "../../models/pure-search-index-model";
import { ISearchSettings } from "../../models/search-settings-model";
import { PureFilterQueryService } from "./filter-query-service";
import { BaseSearchService } from "../base-search-service";

export class PureSearchService extends BaseSearchService<IPureSearchIndex> {
    readonly azureService!: PureAzureSearchService;
    readonly mapper!: PureResultsMapper;

    constructor(language: string, config: ISearchSettings) {
        super();

        this.azureService = new PureAzureSearchService(config.endpoint);
        this.mapper = new PureResultsMapper(language.toUpperCase() == "NL" ? Locale.NL : Locale.EN, config.labels);
    }

    public setFilterQuery(fixedFilters: IDictionary<IFixedFilter>, scopes: IFilterItem[], filters: IDictionary<IFilterItem[]>): void {
        this.filterQuery = new PureFilterQueryService()
            .addUserFilter(filters)
            .filter;
    }

    public setSearchQuery(order: string, query: string, skip: number, limit: number): void {
        this.searchQuery = new Query()
            .SetCount(true)
            .SetFacets(['Model/Faculties, count: 1000', 'Model/Institutes, count: 1000'])
            .SetFilter(this.filterQuery)
            .SetOrderBy(order)
            .SetSearch(query ? query.trim() : '')
            .SetSkip(skip)
            .SetTop(limit);
    }
}
